// utils/timeUtils.js
import moment from 'moment';

// First Created: 23 Jun 2025
// Author: Atul Pandey
// Purpose: Unified time chip filter logic for Today, Week, Month, Quarter, Year
export const isInSelectedTimePeriod = (dateString, activePeriod) => {
  const logDate = moment(dateString);
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  const startOfWeek = moment().isoWeekday(1).startOf("day");
  const endOfWeek = endOfToday;

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");

  switch (activePeriod) {
    case 'today':
      return logDate.isBetween(startOfToday, endOfToday, null, '[]');
    case 'week':
      return logDate.isBetween(startOfWeek, endOfWeek, null, '[]');
    case 'month':
      return logDate.isBetween(startOfMonth, endOfMonth, null, '[]');
    case 'quarter':
      return logDate.isBetween(startOfQuarter, endOfQuarter, null, '[]');
    case 'year':
      return logDate.isBetween(startOfYear, endOfYear, null, '[]');
    default:
      return true;
  }
};
